
import Render              from '@/components/render.vue';
import { Options, Vue }    from 'vue-class-component';
import PaverPicker from '../components/shared/paver-picker.vue'
import { salesqueze } from '../libs/salesqueze-sdk-browser'

@Options({
  components: {
    PaverPicker,
    Render
  },
  data() {
    return {
      errors: this.$store.state.errors || {},
      tiles: this.$store.state.selectedTiles || []
    }
  },
  watch: {
    '$store.state.activeErrors'(value){
      this.errors['tiles'] = value['tiles'];
    }
  },
  methods: {
    getTiles(tiles){
       this.tiles = tiles;
      this.$store.commit('setSelectedTiles', tiles);

      let storeErrors = this.$store.state.errors
      if((this.tiles || []).length === 0 ){
        storeErrors.tiles = 'Polje je obvezno!'
      } else {
        storeErrors.tiles = null
      }
      this.$store.commit('setErrors',storeErrors)
    }
  }
})
export default class ConfigurePage extends Vue {


}
